import { User } from 'src/services/apiInterfaces';

export function getFullName(user: User) {
  if (user.full_name && user.full_name.trim()) {
    return user.full_name.trim();
  }
  let name = user.first_name.trim();
  const lastName = user.last_name.trim();
  if (lastName) {
    name += ` ${lastName}`;
  }
  return name;
}

export function getAvatarTextFromUser(user: User) {
  const fullName = getFullName(user);
  return (fullName || user.email).toUpperCase();
}

// Take snake_case permission level, return string with spaces and capitalized words
// ex: 'SUPER_ADMIN' -> 'Super Admin'
export function formatPermissionLevel(
  permissionLevel: User['permission_level'],
) {
  return permissionLevel
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

const PRE_AUTH_PARAMS_KEY = 'preAuthParams';

export function storePreAuthParams() {
  sessionStorage.setItem(
    PRE_AUTH_PARAMS_KEY,
    JSON.stringify({
      hash: window.location.hash,
      search: window.location.search,
    }),
  );
}

export function setPreAuthParams() {
  const preAuthParams = sessionStorage.getItem(PRE_AUTH_PARAMS_KEY);

  if (preAuthParams) {
    try {
      const { hash, search } = JSON.parse(preAuthParams);
      const newUrl = `${window.location.origin}${window.location.pathname}${search}${hash}`;
      window.history.replaceState(null, '', newUrl);
    } finally {
      sessionStorage.removeItem(PRE_AUTH_PARAMS_KEY);
    }
  }
}
